import React from "react";
import { observer } from "mobx-react";
import { TenantLlmConfigCreateStore } from "../../store";
import { TenantLlmConfigCreateForm } from "./TenantLlmConfigCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type TenantLlmConfigCreateProps = {
  tenantLlmConfigCreateStore: TenantLlmConfigCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantLlmConfigCreate: React.FC<TenantLlmConfigCreateProps> =
  observer(
    ({ tenantLlmConfigCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={tenantLlmConfigCreateStore.isSaving} />
          <TenantLlmConfigCreateForm
            tenantLlmConfigCreateStore={tenantLlmConfigCreateStore}
            providerError={tenantLlmConfigCreateStore.errors.provider?.message}
            onProviderChange={(value) => {
              tenantLlmConfigCreateStore.setProviderValue(value);
            }}
            providerSelectedValue={
              tenantLlmConfigCreateStore.entityValues.showProvider
            }
            onProviderSelected={(value) => {
              tenantLlmConfigCreateStore.setSelectedProvider(value);
            }}
            providerOptions={tenantLlmConfigCreateStore.getProviderOptions()}
            modelError={tenantLlmConfigCreateStore.errors.model?.message}
            onModelChange={(value: string) => {
              tenantLlmConfigCreateStore.setModelValue(value);
            }}
            model={tenantLlmConfigCreateStore.entityValues.model}
            apiKeyError={tenantLlmConfigCreateStore.errors.apiKey?.message}
            onApiKeyChange={(value: string) => {
              tenantLlmConfigCreateStore.setApiKeyValue(value);
            }}
            apiKey={tenantLlmConfigCreateStore.entityValues.apiKey}
            baseUrlError={tenantLlmConfigCreateStore.errors.baseUrl?.message}
            onBaseUrlChange={(value: string) => {
              tenantLlmConfigCreateStore.setBaseUrlValue(value);
            }}
            baseUrl={tenantLlmConfigCreateStore.entityValues.baseUrl}
            enabledError={tenantLlmConfigCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              tenantLlmConfigCreateStore.setEnabledValue(value);
            }}
            enabled={tenantLlmConfigCreateStore.entityValues.enabled}
            priorityError={tenantLlmConfigCreateStore.errors.priority?.message}
            onPriorityChange={(value: number) => {
              tenantLlmConfigCreateStore.setPriorityValue(value);
            }}
            priority={tenantLlmConfigCreateStore.entityValues.priority}
            maxTokensError={
              tenantLlmConfigCreateStore.errors.maxTokens?.message
            }
            onMaxTokensChange={(value: number | undefined) => {
              tenantLlmConfigCreateStore.setMaxTokensValue(value);
            }}
            maxTokens={tenantLlmConfigCreateStore.entityValues.maxTokens}
            temperatureError={
              tenantLlmConfigCreateStore.errors.temperature?.message
            }
            onTemperatureChange={(value: number | undefined) => {
              tenantLlmConfigCreateStore.setTemperatureValue(value);
            }}
            temperature={tenantLlmConfigCreateStore.entityValues.temperature}
            debugFullModeError={
              tenantLlmConfigCreateStore.errors.debugFullMode?.message
            }
            onDebugFullModeChange={(value: boolean) => {
              tenantLlmConfigCreateStore.setDebugFullModeValue(value);
            }}
            debugFullMode={
              tenantLlmConfigCreateStore.entityValues.debugFullMode
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={tenantLlmConfigCreateStore.isProcessing}
            onSave={() => tenantLlmConfigCreateStore.saveNewTenantLlmConfig()}
            onCancel={() =>
              tenantLlmConfigCreateStore.cancelNewTenantLlmConfig()
            }
          />
          <ErrorDialog
            open={tenantLlmConfigCreateStore.errorDialogOpened}
            title={tenantLlmConfigCreateStore.errorTitle}
            description={tenantLlmConfigCreateStore.errorDescription}
            onClose={() => tenantLlmConfigCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
